/** The platform field preset to apply when files are opened; chosen on the landing page. */
export const fieldPresetKey = 'cdr-clarity:field-preset:v1';
export const defaultFieldPreset = 'basic-logs';

export function readFieldPreset(storage: Pick<Storage, 'getItem'>): string {
  try {
    const saved = storage.getItem(fieldPresetKey);
    return saved && /^[\w-]{1,160}$/.test(saved) ? saved : defaultFieldPreset;
  } catch {
    return defaultFieldPreset;
  }
}

export function saveFieldPreset(storage: Pick<Storage, 'setItem'>, id: string): void {
  try {
    storage.setItem(fieldPresetKey, id);
  } catch {
    // Private browsing or a full store: the choice still applies to this session.
  }
}
